require('angular');

angular.module('app').controller('feedbackController', feedbackController);
feedbackController.$inject = ['$http', '$scope'];
function feedbackController($http, $scope) {
    var vm = this;

    vm.submit = submit;
    vm.isProcessing = false;
    vm.success = null;
    vm.showMessage = false;
    vm.message = null;
    vm.showFormDetails = false;

    vm.customerName2 = '';
    vm.customerName = '';
    vm.customerEmail = '';
    vm.customerOpinion = '';
    vm.servicesIds = [];
    vm.rate = null;
    vm.recaptchaToken = '';

    function submit() {
        vm.isProcessing = true;
        vm.showMessage = false;
        vm.success = null;
        vm.message = null;

        const formRef = $scope.feedbackForm;
        if(formRef.$invalid){
            $scope.$apply(function() {
                formRef.rate.$setTouched();
                if(formRef.servicesIds){
                    formRef.servicesIds.$setTouched();
                }
                formRef.customerName.$setTouched();
                formRef.customerEmail.$setTouched();
                formRef.customerOpinion.$setTouched();
                vm.isProcessing = false;
            });
            return;
        }

        $http({
            method: 'POST',
            async: false,
            dataType: 'json',
            url: '/wp-admin/admin-ajax.php',
            params: {
                action: 'create-new-feedback',
                customer_name: vm.customerName,
                customer_email: vm.customerEmail,
                customer_opinion: vm.customerOpinion,
                'services_ids[]': vm.servicesIds,
                rate: vm.rate,
                recaptchaToken: vm.recaptchaToken
            }
        }).then(onSuccess, onFail);
    }

    function onSuccess(response) {
        vm.isProcessing = false;
        vm.success = response['data']['data']['success'];
        vm.message = response['data']['data']['message'];
        vm.showMessage = true;
    }

    function onFail(err) {
        vm.isProcessing = false;
    }

}
